export default "__VITE_ASSET__uu0vMyYr__"